import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
} from 'react';
import classNames from 'classnames';
import { SideDrawerRef } from '../SideDrawer/SideDrawer.component';
import SideDrawer from '../SideDrawer';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import QuestionSubjectsForm from './QuestionSubjectsForm';

import './ManageQuestionSubjectsDrawer.styles.scss';

type ManageQuestionSubjectsDrawerProps = {
  className?: string;
  afterEditSuccess?: (newName: string, oldName: string) => void;
  afterDeleteSuccess?: (name: string) => void;
};

const ManageQuestionSubjectsDrawer: ForwardRefRenderFunction<
  SideDrawerRef,
  ManageQuestionSubjectsDrawerProps
> = (props, ref) => {
  const { className, afterDeleteSuccess, afterEditSuccess } = props;

  const [drawer, drawerRef] = useCallbackRef<SideDrawerRef>(null);

  useImperativeHandle(ref, () => drawer, [drawer]);

  const { t } = useTranslation();

  const classes = classNames('manage-question-subjects-drawer', className);

  return (
    <SideDrawer ref={drawerRef} className={classes}>
      <p className="title">{t('editQASubject')}</p>
      <p className="description">{t('editQASubjectDescription')}</p>
      <QuestionSubjectsForm
        afterDeleteSuccess={afterDeleteSuccess}
        afterEditSuccess={afterEditSuccess}
      />
    </SideDrawer>
  );
};

export default forwardRef(ManageQuestionSubjectsDrawer);
